<template>
  <div class="open-app">
    <!-- 提示微信分享弹窗 -->
    <van-overlay :show="show" @click="show = false" z-index="99999">
      <img src="@/assets/live_weixin.png" style="width: 100%; margin-left: 0" alt=""/>
    </van-overlay>
  </div>
</template>

<script>

import {Toast} from "vant";
import {isAppleMobileDevice, isWeChatOpen} from "@/common/util";
import CallApp from "callapp-lib";
import {SCHEME_ANDRIOD, SCHEME_IOS} from "@/common/config";
// 打开APP初始化
const callLib = new CallApp({
  scheme: {
    protocol: isAppleMobileDevice() ? SCHEME_IOS : SCHEME_ANDRIOD,
  },
});
export default {
  name: 'open-app',
  data() {
    return {
      show: false,
    };
  },
  methods: {
    openApp(path) {
      if (isWeChatOpen()) {
        return this.show = true;
      }
      const loading = Toast.loading({message: '正在打开..'});
      setTimeout(() => loading.clear(), 5000);
      callLib.open({
        path: '',
        callback: () => {
          loading.clear();
          if (isAppleMobileDevice()) {
            location.href = 'https://gaoyixia.hdlkeji.com/apidoc/?appKey=V1.0'
          } else {
            location.href = `myinfo://gyx.net:8888${path}`
          }
        },
      });
    }
  },
}
</script>

<style scoped>
</style>
